/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import React, {useContext, useState} from 'react';
import {AppContext} from "../../misc/appContext";
import {login} from "../../../util/requestSender";
import User from "../../../models/userModel";
import {ErrorType, ResponseData, setJwt, showDialog, validateEmail} from '@dvrd/dvr-controls';
import {useNavigate} from 'react-router-dom';
import LoginView from "./loginView";

export default function LoginController() {
    const context = useContext(AppContext);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<ErrorType>(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    function onChangeEmail(value: string) {
        setEmail(value);
    }

    function onChangePassword(value: string) {
        setPassword(value);
    }

    function onResetError() {
        setError(null);
    }

    function onSubmit() {
        if (!validateValues()) return;
        setLoading(true);
        login({
            data: {email, password},
            callback: (data: ResponseData) => {
                setLoading(false);
                if (data.success) {
                    setJwt(data.token);
                    context.onChangeContext({user: new User(data.user)}, () => {
                        navigate('/downloader');
                    })
                } else if (data.message) setError(data.message);
                else showDialog('Login failed, please try again later or contact us.', 'Login failed');
            }
        });
    }

    function validateValues(): boolean {
        let error = null;
        if (!email.length) error = 'Enter your email';
        else if (!validateEmail(email)) error = 'Enter a valid email adress';
        else if (!password.length) error = 'Enter your password';
        if (error) setError(error);
        return !error;
    }

    return (
        <LoginView onSubmit={onSubmit} onChangeEmail={onChangeEmail} onChangePassword={onChangePassword}
                   onResetError={onResetError} email={email} password={password} loading={loading} error={error}/>
    )
}